import axios from "axios";

export default {
  methods: {
    /// PTUS COM ERRO

    /**
     * Método que serve para popular a tabela
     * @param  {Object} params - Objeto padrão usado na querystring
     * @return {Promise<
     * {
     *    "conteudo": [
     *      {
     *        "id": 0,
     *        "nomeArquivo": "String",
     *        "data": "String"
     *      }
     *    ],
     *    "numeroPagina": 0,
     *    "tamanhoPagina": 0,
     *    "totalElementos": 0,
     *    "totalPaginas": 0
     *  }
     * >}
     */
    getListaPtuErro(params) {
      return axios.get(
        this.CriarUrl(
          {
            resource: `relatorios/ptuComErros/listagem`,
            params
          },
          { apiRelatorio: true }
        )
      );
    },
    getDownloadSelecionadoPtuErro(params, config) {
      return axios.get(
        this.CriarUrl(
          {
            resource: `relatorios/ptuComErros/download/selecionados`,
            params
          },
          { apiRelatorio: true }
        ),
        {
          responseType: "blob",
          ...config
        }
      );
    },
    getDownloadTodosPtuErro(params, config) {
      return axios.get(
        this.CriarUrl(
          {
            resource: `relatorios/ptuComErros/download/todos`,
            params
          },
          { apiRelatorio: true }
        ),
        {
          responseType: "blob",
          ...config
        }
      );
    },

    /// RPS TOTAL

    /**
     * URL
     * `api/relatorios/rpsTotal/arquivo`
     *
     * @example
     *  {
     *    nomeArquivo: "rps-total.zip",
     *    tamanhoArquivo: 2500000
     *  }
     *
     * @return {
     *      {
     *        nomeArquivo: String,
     *        tamanhoArquivo: Number
     *      }
     * }
     *
     */
    getArquivoRpsTotal() {
      return axios.get(
        this.CriarUrl(
          {
            resource: `relatorios/rpsTotal/arquivo`
          },
          { apiRelatorio: true }
        )
      );
    },

    /**
     * URL
     * relatorios/rpsTotal/download
     *
     * @example
     * // Retorna no mesmo padrão dos outros relatórios
     *
     * @return {Blob}
     */
    getDownloadRpsTotal(params, config) {
      console.log(config);
      return axios.get(
        this.CriarUrl(
          {
            resource: `relatorios/rpsTotal/download`,
            params
          },
          { apiRelatorio: true }
        ),
        {
          responseType: "blob",
          ...config
        }
      );
    },

    /// ARPS/RPS - ANS

    /**
     * URL
     * `api/relatorios/arpsRpsAns/arquivo`
     *
     * @example
     *  // exemplo de retorno
     *  {
     *    rede: {
     *      chave: "REDE_BASICA",
     *      descricao: "Rede básica"
     *    },
     *    quantidadeArquivos: 3
     *  }
     *
     * @return {
     *   [
     *      {
     *        rede: {
     *          chave: String,
     *          descricao: String
     *        },
     *        quantidadeArquivos: Number
     *      }
     *    ]
     * }
     *
     */
    getArquivosArpsRpsAns() {
      return axios.get(
        this.CriarUrl(
          {
            resource: `relatorios/arpsRpsAns/arquivo`
          },
          { apiRelatorio: true }
        )
      );
    },

    /**
     * URL
     * api/relatorios/arpsRps/download?rede=...
     * O campo rede equivale a chave enviado pelo back na
     * listagem de arquivos
     *
     * @example
     * // Retorna no mesmo padrão dos outros relatórios
     *
     * @return {Blob}
     */
    getDownloadArpsRpsAns(params, config) {
      return axios.get(
        this.CriarUrl(
          {
            resource: `relatorios/arpsRps/download`,
            params
          },
          { apiRelatorio: true }
        ),
        {
          responseType: "blob",
          ...config
        }
      );
    },

    /// REDE NACIONAL DE PRESTADORES

    /**
     * URL
     * relatorios/redeNacionalPrestador/statusPrestador
     *
     * @example
     * [
     *   {
     *     chave: "HOSPITAL_DIA",
     *     descricao: "Hospital Dia"
     *   }
     * ]
     *
     * @return {
     *   [
     *     {
     *       chave: String,
     *       descricao: String
     *     }
     *   ]
     * }
     */
    getListaTipoPrestadores() {
      return axios.get(
        this.CriarUrl(
          {
            resource: `relatorios/redeNacionalPrestador/opcoesTipoPrestador`
          },
          { apiRelatorio: true }
        )
      );
    },

    /**
     * URL
     * relatorios/redeNacionalPrestador/arquivo
     *
     * @example
     *  {
     *    nomeArquivo: "teste.zip",
     *    tamanhoArquivo: 5
     *  }
     *
     * @return {
     *      {
     *        nomeArquivo: String,
     *        quantidadeArquivo: Number
     *      }
     * }
     *
     */
    getArquivoRedeNacionalPrestador(params) {
      return axios.get(
        this.CriarUrl(
          {
            resource: `relatorios/redeNacionalPrestador/arquivo`,
            params
          },
          { apiRelatorio: true }
        )
      );
    },

    /**
     * URL
     * relatorios/redeNacionalPrestador/download
     *
     * @example
     * // Retorna no mesmo padrão dos outros relatórios
     *
     * @return {Blob}
     */
    getDownloadRedeNacionalPrestador(params, config) {
      return axios.get(
        this.CriarUrl(
          {
            resource: `relatorios/redeNacionalPrestador/download`,
            params
          },
          { apiRelatorio: true }
        ),
        {
          responseType: "blob",
          ...config
        }
      );
    },

    getDownloadSelecionadosRedeNacionalPrestador(params, config) {
      return axios.get(
        this.CriarUrl(
          {
            resource: `relatorios/redeNacionalPrestador/download/selecionados`,
            params
          },
          { apiRelatorio: true }
        ),
        {
          responseType: "blob",
          ...config
        }
      );
    },

    getDownloadTodosRedeNacionalPrestador(config) {
      return axios.get(
        this.CriarUrl(
          {
            resource: `relatorios/redeNacionalPrestador/download/todos`
          },
          { apiRelatorio: true }
        ),
        {
          responseType: "blob",
          ...config
        }
      );
    },

    getArquivosRedeNacionalPrestador(params) {
      return axios.get(
        this.CriarUrl(
          {
            resource: `relatorios/redeNacionalPrestador/listagem`,
            params
          },
          { apiRelatorio: true }
        )
      );
    },

    /// REDIMENSIONAMENTO HOSPITALAR

    /**
     * URL
     * relatorios/redimensionamentoHospitalar/statusPrestador
     *
     * @example
     * {
     *   chave: "ALTERACAO_CNPJ",
     *   descricao: "Alteração de CNPJ"
     * }
     *
     * @return {
     *   [
     *     {
     *       chave: String,
     *       descricao: String
     *     }
     *   ]
     * }
     */
    getListaStatusPrestadores() {
      return axios.get(
        this.CriarUrl(
          {
            resource: `relatorios/redimensionamentoHospitalar/statusPrestador`
          },
          { apiRelatorio: true }
        )
      );
    },

    /**
     * URL
     * relatorios/redimensionamentoHospitalar/arquivo?filtro
     * O filtro aqui seria algo como: ?chavePrestador=...&competencia=...
     *
     * @example
     *  {
     *    nomeArquivo: "teste.zip",
     *    tamanhoArquivo: 5
     *  }
     *
     * @return {
     *      {
     *        nomeArquivo: String,
     *        quantidadeArquivo: Number
     *      }
     * }
     *
     */
    getArquivoRedimensionamentoHospitalar(params) {
      return axios.get(
        this.CriarUrl(
          {
            resource: `relatorios/redimensionamentoHospitalar/arquivo`,
            params
          },
          { apiRelatorio: true }
        )
      );
    },

    /**
     * URL
     * relatorios/redimensionamentoHospitalar/download?filtro
     * O filtro aqui seria algo como: ?chavePrestador=...&competencia=...
     *
     * @example
     * // Retorna no mesmo padrão dos outros relatórios
     *
     * @return {Blob}
     */
    getDownloadRedimensionamentoHospitalar(params, config) {
      return axios.get(
        this.CriarUrl(
          {
            resource: `relatorios/redimensionamentoHospitalar/download`,
            params
          },
          { apiRelatorio: true }
        ),
        {
          responseType: "blob",
          ...config
        }
      );
    },
    /**
     * URL
     * relatorios/redimensionamentoHospitalar/rn620/arquivo?filtro
     * O filtro aqui seria algo como: ?chavePrestador=...&competencia=...
     *
     * @example
     *  {
     *    nomeArquivo: "teste.zip",
     *    tamanhoArquivo: 5
     *  }
     *
     * @return {
     *      {
     *        nomeArquivo: String,
     *        quantidadeArquivo: Number
     *      }
     * }
     *
     */
    getArquivoRedimensionamentoHospitalarRn620(params) {
      return axios.get(
        this.CriarUrl(
          {
            resource: `relatorios/redimensionamentoHospitalar/agi/arquivo`,
            params
          },
          { apiRelatorio: true }
        )
      );
    },

    /**
     * URL
     * relatorios/redimensionamentoHospitalar/rn620/download?filtro
     * O filtro aqui seria algo como: ?chavePrestador=...&competencia=...
     *
     * @example
     * // Retorna no mesmo padrão dos outros relatórios
     *
     * @return {Blob}
     */
    getDownloadRedimensionamentoHospitalarRn620(params, config) {
      return axios.get(
        this.CriarUrl(
          {
            resource: `relatorios/redimensionamentoHospitalar/agi/download`,
            params
          },
          { apiRelatorio: true }
        ),
        {
          responseType: "blob",
          ...config
        }
      );
    },

    /// SUBSTITUIÇÃO DE PRESTADORES

    /**
     * URL
     * `api/relatorios/substituicaoPrestadores/arquivo`
     *
     * @example
     *  {
     *    nomeArquivo: "rps-total.zip",
     *    tamanhoArquivo: 2500000
     *  }
     *
     * @return {
     *      {
     *        nomeArquivo: String,
     *        tamanhoArquivo: Number
     *      }
     * }
     *
     */
    getArquivoSubstituicaoPrestadores(params) {
      return axios.get(
        this.CriarUrl(
          {
            resource: `relatorios/substituicaoPrestadores/arquivo`,
            params
          },
          { apiRelatorio: true }
        )
      );
    },

    /**
     * URL
     * relatorios/substituicaoPrestadores/download
     *
     * @example
     * // Retorna no mesmo padrão dos outros relatórios
     *
     * @return {Blob}
     */
    getDownloadSubstituicaoPrestadores(config, params) {
      return axios.get(
        this.CriarUrl(
          {
            resource: `relatorios/substituicaoPrestadores/download`,
            params
          },
          { apiRelatorio: true }
        ),
        {
          responseType: "blob",
          ...config
        }
      );
    },

    /**
     * URL
     * `api/relatorios/substituicaoPrestadores/agi/arquivo`
     *
     * @example
     *  {
     *    nomeArquivo: "rps-total.zip",
     *    tamanhoArquivo: 2500000
     *  }
     *
     * @return {
     *      {
     *        nomeArquivo: String,
     *        tamanhoArquivo: Number
     *      }
     * }
     *
     */
    getArquivoSubstituicaoPrestadoresAgi(params) {
      return axios.get(
        this.CriarUrl(
          {
            resource: `relatorios/substituicaoPrestadores/agi/arquivo`,
            params
          },
          { apiRelatorio: true }
        )
      );
    },

    /**
     * URL
     * relatorios/substituicaoPrestadores/agi/download
     *
     * @example
     * // Retorna no mesmo padrão dos outros relatórios
     *
     * @return {Blob}
     */
    getDownloadSubstituicaoPrestadoresAgi(config, params) {
      return axios.get(
        this.CriarUrl(
          {
            resource: `relatorios/substituicaoPrestadores/agi/download`,
            params
          },
          { apiRelatorio: true }
        ),
        {
          responseType: "blob",
          ...config
        }
      );
    },

    /// LISTA DE PRESTADORES

    /**
     * URL
     * api/relatorios/listaPrestador/arquivo?Filtro
     * no caso o filtro seria equivalente à "?unimed=..."
     *
     * @example
     *  {
     *    nomeArquivo: "rps-total.zip",
     *    tamanhoArquivo: 2500000
     *  }
     *
     * @return {
     *      {
     *        nomeArquivo: String,
     *        tamanhoArquivo: Number
     *      }
     * }
     *
     */
    getArquivoListaPrestadores(params) {
      return axios.get(
        this.CriarUrl(
          {
            resource: `relatorios/listaPrestador/arquivo`,
            params
          },
          { apiRelatorio: true }
        )
      );
    },

    /**
     * URL
     * relatorios/listaPrestador/download
     *
     * @example
     * // Retorna no mesmo padrão dos outros relatórios
     *
     * @return {Blob}
     */
    getDownloadListaPrestadores(params, config) {
      return axios.get(
        this.CriarUrl(
          {
            resource: `relatorios/listaPrestador/download`,
            params
          },
          { apiRelatorio: true }
        ),
        {
          responseType: "blob",
          ...config
        }
      );
    },

    /// EVOLUÇÃO A400

    /**
     * URL
     * api/relatorios/evolucaoA400/arquivo?Filtro
     * no caso o filtro seria equivalente à "?unimed=...&competencia=..."
     *
     * @example
     *  {
     *    nomeArquivo: "rps-total.zip",
     *    tamanhoArquivo: 2500000
     *  }
     *
     * @return {
     *      {
     *        nomeArquivo: String,
     *        tamanhoArquivo: Number
     *      }
     * }
     *
     */
    getArquivoEvolucaoA400(params) {
      return axios.get(
        this.CriarUrl(
          {
            resource: `relatorios/evolucaoA400/arquivo`,
            params
          },
          { apiRelatorio: true }
        )
      );
    },

    /**
     * URL
     * relatorios/evolucaoA400/download
     *
     * @example
     * // Retorna no mesmo padrão dos outros relatórios
     *
     * @return {Blob}
     */
    getDownloadEvolucaoA400(params, config) {
      return axios.get(
        this.CriarUrl(
          {
            resource: `relatorios/evolucaoA400/download`,
            params
          },
          { apiRelatorio: true }
        ),
        {
          responseType: "blob",
          ...config
        }
      );
    },

    /// PRESTADORES PENDENTES À JUSTIFICATIVA

    getDownloadPrestadoresPendentesJustificativa(params) {
      return axios.get(
        this.CriarUrl(
          {
            resource: `relatorios/prestadoresPendentesJustificativa/download`,
            params
          },
          { apiRelatorio: true }
        ),
        {
          responseType: "blob"
        }
      );
    },

    getInformacoesPrestadoresPendentesJustificativa(params) {
      return axios.get(
        this.CriarUrl(
          {
            resource: `relatorios/prestadoresPendentesJustificativa/arquivo`,
            params
          },
          { apiRelatorio: true }
        )
      );
    },

    getPrestadoresIndisponiveisAoIntercambio(params) {
      return axios.get(
        this.CriarUrl(
          {
            resource: `relatorios/prestadoresIndisponiveisAoIntercambio/arquivo`,
            params
          },
          { apiRelatorio: true }
        )
      );
    },

    getDownloadPrestadoresIndisponiveisAoIntercambio(params, config) {
      return axios.get(
        this.CriarUrl(
          {
            resource: `relatorios/prestadoresIndisponiveisAoIntercambio/download`,
            params
          },
          { apiRelatorio: true }
        ),
        {
          responseType: "blob",
          ...config
        }
      );
    },

    getAllEnderecos() {
      return axios.get(this.CriarUrl({ resource: `endereco/estados` }));
    },

    /// PRESTADORES UNIMED NAO OPERADORA

    /**
     * URL
     * `/api/relatorios/prestadoresNaoOperadoras/arquivo`
     *
     * @example
     *  {
     *    nomeArquivo: "prestadores-unimed-nao-operadora.xlsx",
     *  }
     *
     * @return {
     *      {
     *        nomeArquivo: String
     *      }
     * }
     *
     */
    getArquivoPrestadoresNaoOperadora() {
      return axios.get(
        this.CriarUrl(
          {
            resource: `relatorios/prestadoresNaoOperadoras/arquivo`
          },
          { apiRelatorio: true }
        )
      );
    },

    /**
     * URL
     * relatorios/prestadoresNaoOperadoras/download
     *
     * @example
     * // Retorna no mesmo padrão dos outros relatórios
     *
     * @return {Blob}
     */
    getDownloadPrestadoresNaoOperadora(config) {
      console.log(config);
      return axios.get(
        this.CriarUrl(
          {
            resource: `relatorios/prestadoresNaoOperadoras/download`
          },
          { apiRelatorio: true }
        ),
        {
          responseType: "blob",
          ...config
        }
      );
    }
  }
};
